import { t } from '@/store/modules/homeDrushim/constantsContent';

export const nameRules = [v => !!v || t('titles.requiredField'),
v => /^.{2,}$/.test(v) || t('titles.requiredField')];

export const emailRules = [
  v => !!v || t('titles.requiredField'),
  v =>
    /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v) ||
    t('titles.invalidEmail')
];

export const passwordRules = [
  v => !!v || t('titles.requiredField'),
  v => /^.{6,}$/.test(v) || t('titles.invalidPassword')
];

export const termsRules = [v => !!v || t('titles.termsRules')];

export const comboRules = [v => !!v || t('titles.requiredField')];

export const catRules = [v => !!v || t('titles.requiredField')];

export const locationRules = [v => !!v || t('titles.requiredField')];

export const phoneRules = [
  v => !!v || t('titles.requiredField'),
  v => /[0][5]\d{8}$/.test(v) || t('titles.phoneFieldLength')
  // /^0\d([\d]{0,1})([-]{0,1})\d{3,7}([-]{0,1})\d{0,4}$/.test(v)
];

export const radioRules = [v => !!v || 'שדה חובה'];

export const textareaRules = [
  v => /^[^#%^&*()"{}|<>]+$/.test(v) || 'תוכן לא תקין , מחק תווים מיוחדים'
];
